"use client";

import React from "react";

import {
  ProductLine,
  ProductLineFlexibleHeight,
} from "@faire/retailer/features/MarketplaceItems/styled";

export const ProductName = ({ productName }: { productName: string }) => {
  return (
    <ProductLine $noSpacing data-no-spacing="true">
      <ProductLineFlexibleHeight data-test-id="product-tile-product-name">
        {productName}
      </ProductLineFlexibleHeight>
    </ProductLine>
  );
};
